import {IViewAsState} from '../types/IViewAsState'

export const DefaultViewAsState: IViewAsState = {
  token: null,
  sessionId: null,
  workspaceId: null,
  targetEntityType: null,
  targetEntityId: null,
  targetLabel: null,
  expiresAt: null,
}
